export default (state = {}, action) => {
  switch (action.type) {
    case 'CANCELLATION_DONE':
      return {
        ...state,
        cancelled: true
      }
    default:
      return state
  }
}
